import { generateUUID2 } from "@/utils";

let mDb: any;
let mTemplate: any;

/**
 * 模板表结构：
 * id: 唯一标识
 * name: 模板名称
 * content: 模板内容 (HTML字符串)
 * createTime: 创建时间
 * updateTime: 更新时间
 */
export function initTemplate(db: any) {
    mDb = db;
    mTemplate = db.table('template');
}

/**
 * 创建模板
 * @param name 模板名称
 * @param content 模板内容 (HTML字符串)
 */
export async function createTemplate(name: string, content: string) {
    const now = Date.now();
    const template = {
        id: generateUUID2(),
        name,
        content,
        createTime: now,
        updateTime: now,
    };
    await mTemplate.put(template);
    return template;
}

/**
 * 更新模板
 * @param template 模板对象
 */
export async function updateTemplate(template: any) {
    template.updateTime = Date.now();
    await mTemplate.put(template);
    return template;
}

/**
 * 删除模板
 * @param id 模板ID
 */
export function deleteTemplate(id: string) {
    return mTemplate.delete(id);
}

/**
 * 根据ID获取模板
 * @param id 模板ID
 */
export function getTemplateById(id: string) {
    return mTemplate.get(id);
}

/**
 * 获取所有模板列表
 */
export function getTemplateList() {
    return mTemplate.orderBy('updateTime').reverse().toArray();
}

/**
 * 根据名称搜索模板
 * @param keyword 关键词
 */
export async function searchTemplates(keyword: string) {
    const allTemplates = await mTemplate.toArray();
    if (!keyword) return allTemplates;
    const lowerKeyword = keyword.toLowerCase();
    return allTemplates.filter((t: any) => 
        t.name?.toLowerCase().includes(lowerKeyword)
    );
}

